export default {"src":"/_next/static/media/Share.7482404a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};